import React from 'react';
import {
  Grid,
  GridCol,
  Section,
  Skeleton,
  TextContainer,
} from '../../../../components/';

export const ImageSkeleton = () => <Skeleton height="180px" />;

export const ContentSkeleton = () => (
  <React.Fragment>
    <h5>
      <Skeleton />
      <Skeleton />
    </h5>
    <p>
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </p>
  </React.Fragment>
);

export const PostSkeleton = () =>
  [...Array(10)].map((_, index) => (
    <Section
      space="small"
      className="post"
      // eslint-disable-next-line react/no-array-index-key
      key={index}
    >
      <Grid>
        <GridCol size={{ xs: 26, s: 10, l: 4 }}>
          <ImageSkeleton />
        </GridCol>
        <GridCol size={{ xs: 26, s: 16, l: 8 }}>
          <TextContainer>
            <ContentSkeleton />
          </TextContainer>
        </GridCol>
      </Grid>
    </Section>
  ));



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/Post/Skeleton.js